import React from 'react';
import './ComingSoonBadge.css';


export default class ComingSoonBadge extends React.Component {

  render() {
    return (
      <div className="coming-soon-badge">coming soon</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/ComingSoonBadge.jsx